import {React, useState,useEffect} from 'react'
import './Nav.css'
function Nav() {
    const [show, handleShow] = useState(false)

    const transitionNavBar = () =>{
        if(window.scrollY > 100){
            handleShow(true)
        }
        else{
            handleShow(false)
        }
    }


    useEffect(()=>{
        window.addEventListener('scrool', transitionNavBar)
        return window.addEventListener('scroll', transitionNavBar)
    },[])

  return (
    <div className={`nav ${show && 'nav_black'}`}>
    <div className='nav-contents'>
      <img className='nav_logo' src='https://assets.stickpng.com/images/580b57fcd9996e24bc43c529.png' alt='logo' />
      <img className='nav_avatar' src='https://i.ibb.co/JzcgMqF/Seek-Png-com-default-avatar-png-5147412.png' alt='' />
    </div>
    </div>
  )
}

export default Nav
